<script setup>
import { computed } from 'vue';
import { trans } from '@elements/translation';

const props = defineProps({
  modelValue: { type: Number, default: null },
  error: { type: String, default: null },
  validationRules: { type: Object, required: true },
});

const emit = defineEmits([ 'update:modelValue' ]);

const capacity = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value === '' ? null : value),
});
</script>

<template>
  <div class="content-form__field form-field">
    <label
      class="form-field__label field-label"
      for="capacity"
    >
      <span>{{ trans('addresses.details.form.field.capacity.label') }}</span>
    </label>
    <div class="form-field__input field-input field-input--small input-text input-text--legend">
      <input
        id="capacity"
        v-model.number="capacity"
        type="number"
        :min="validationRules.min"
        :max="validationRules.max"
        name="capacity"
        :class="{ error: error !== null }"
        placeholder="0"
        @focusout="$emit('focusout')"
      >
      <span>{{ trans('global.capacity_unit') }}</span>
    </div>
    <span v-if="error" class="form-field__error">
      {{ error }}
    </span>
  </div>
</template>
